import { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon, FolderIcon, FolderOpenIcon } from "@heroicons/react/24/outline";

interface TagTreeItemProps {
    tag: any;
    level?: number;
  }
  

const TagTreeItem = ({ tag, level = 0 }: TagTreeItemProps) => {
        const [isOpen, setIsOpen] = useState(false);

        const hasChildren = tag.subtags?.length > 0;
        const paddingLeft = `${level * 20}px`;
      
        return (
          <div>
            <div 
              className="flex items-center py-1 text-xs hover:bg-gray-50 cursor-pointer"
              style={{ paddingLeft }}
              onClick={() => setIsOpen(!isOpen)}
            >
              {hasChildren && (
                <span className="mr-1">
                  {isOpen ? <ChevronDownIcon  className="h-3 w-3"/> : <ChevronRightIcon  className="h-3 w-3"/>}
                </span>
              )}
              {isOpen ? <FolderOpenIcon className="mr-2 h-3 w-3 text-yellow-600" /> : <FolderIcon className="mr-2 h-3 w-3 text-yellow-600" />}
              <span className="font-medium text-xs text-black dark:text-gray-300">{tag.name}</span>
              <span className="ml-2 text-sm text-gray-500">
              </span>
            </div>
      
            {isOpen && (
              <div className="ml-4"> 
      
                {
                    tag.subtags 
                    && tag.subtags.map((subtag: any) => (
                        <TagTreeItem
                          key={subtag.id}
                          tag={subtag}
                          level={level + 1}
                        />
                    ))}
              </div>
            )}
            </div>
        )
    }

export default TagTreeItem
